import React from 'react';

export default function AppRestrict() {
  return <div>This website is restricted to ICRS specific ldap groups only.</div>;
}
